import React, { useContext } from 'react'
import '../../src/assets/AdminCss/card.css'
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { AuthContext, base_url } from '../context/Authcontext';
import axios from 'axios';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { useEffect } from 'react';
import { useState } from 'react';
import LoginReg from './LoginReg';

const PgSoftAll = () => {
    const navigate= useNavigate();
    const { userdata } = useContext(AuthContext);
    const [isSidebar, setSidebar] = useState(false);
    const [active, setActive]=useState(false);
    const allGames=[
        {
          name: "Mahjong Ways",
          GAMEID: "1189baca156e1bbbecc3b26651a63565",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Mahjong-Ways_rounded_1024.png"
        },
        {
          name: "Mahjong Ways 2",
          GAMEID: "ba2adf72179e1ead9e3dae8f0a7d4c07",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Mahjong-Ways2_rounded_1024.png"
        },
        {
          name: "Treasures of Aztec",
          GAMEID: "2fa9a84d096d6ff0bab53f81b79876c8",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Treasures-of-Aztec_rounded_1024.png"
        },
        {
          name: "Leprechaun Riches",
          GAMEID: "fb2a2ac51303c0a0801dbe6a72d936f7",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Leprechaun-Riches_rounded_1024.png"
        },
        {
          name: "Lucky Neko",
          GAMEID: "e1b4c6b95746d519228744771f15fe4b",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Lucky-Neko_icon_1024_rounded.png"
        },
        {
          name: "Captain's Bounty",
          GAMEID: "cd29b9906a852ce26b53b6d6d81037d4",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Captains-Bounty_Icon_Rounded_1024.png"
        },
        {
          name: "Queen of Bounty",
          GAMEID: "83a6890cf84e4c5a6bacf96d5355d472",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Queen-of-Bounty_1024_rounded.png"
        },
        {
          name: "Wild Bandito",
          GAMEID: "95fc290bb05c07b5aad1a054eba4dcc4",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Wild-Bandito_icon_1024_rounded.png"
        },
        {
          name: "Ways of the Qilin",
          GAMEID: "fedfca553a97a791a3a41c4f1e3bff58",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Ways-of-the-Qilin_icon_1024_rounded.png"
        },
        {
          name: "Dragon Hatch",
          GAMEID: "4afef91d3addb9ce5107abaf3342b9a5",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Dragon-Hatch_rounded_1024.png"
        },
        {
          name: "Double Fortune",
          GAMEID: "3810e528e0abb8ce1cd7ddc2ece005c0",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Double-Fortune_Icon_Rounded_1024.png"
        },
        {
          name: "The Great Icescape",
          GAMEID: "99f07ed2226f37e22570325fc1c078f2",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/The-Great-Icescape_Icon_Rounded_1024.png"
        },
        {
          name: "Caishen Wins",
          GAMEID: "82a810ba99a5fb3e23fc514afebd6314",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Caishen-Wins_rounded_1024.png"
        },
        {
          name: "Ganesha Fortune",
          GAMEID: "c4b57c6dcfac5c8a31b9174523103c8c",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Ganesha-Fortune_rounded_1024.png"
        },
        {
          name: "Dreams of Macau",
          GAMEID: "0ef82ebe6f819619f53b83e218b9452c",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Dreams-of-Macau_rounded_1024.png"
        },
        {
          name: "Fortune Ox",
          GAMEID: "8db4eb6d781f915eebab2a26133db0e9",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Fortune-Ox_icon_1024_rounded.png"
        },
        {
          name: "Wild Bounty Showdown",
          GAMEID: "c98bb64436826fe9a2c62955ff70cba9",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Wild-Bounty-Showdown_1024_rounded.png"
        },
        {
          name: "Prosperity Fortune Tree",
          GAMEID: "0da0fda6981138234f03cb665984c07e",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Prosperity-Fortune-Tree_rounded_1024.png"
        },
        {
          name: "Diner Delights",
          GAMEID: "7e6298970ad1c3c983e495be86833dee",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Diner-Delights_icon_1024_rounded.png"
        },
        {
          name: "Egypt's Book of Mystery",
          GAMEID: "1babfc499be7bc670f11695e8668b59d",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Egypts-Book-of-Mystery_icon_1024_rounded.png"
        },
        {
          name: "Phoenix Rises",
          GAMEID: "21c55c4cd28bb1ebf465fcfaf413477c",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Phoenix-Rises_app-icon_rounded_1024.png"
        },
        {
          name: "Wild Fireworks",
          GAMEID: "fb8888b2dec33fe9d28996376580b410",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Wild-Fireworks_icon_1024_rounded.png"
        },
        {
          name: "Thai River Wonders",
          GAMEID: "fcc6918b79eddf49984d4f5f650c8ded",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Thai-River-Wonders_icon_1024_rounded.png"
        },
        {
          name: "Bali Vacation",
          GAMEID: "c79544b2cf7a3326c85f6ab5bdf53d25",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Bali-Vacation_icon_1024_rounded.png"
        },
        {
          name: "Crypto Gold",
          GAMEID: "b1e11902cecf38023f2916569c32040a",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Crypto-Gold_icon_1024_rounded.png"
        },
        {
          name: "Jurassic Kingdom",
          GAMEID: "4eef5090166a6889956a630321713366",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Jurassic-Kingdom_icon_1024_rounded.png"
        },
        {
          name: "Cocktail Nights",
          GAMEID: "5bea5667515cb7a31f6f07dc3caa13b1",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Cocktail-Nights_1024_rounded.png"
        },
        {
          name: "Fortune Tiger",
          GAMEID: "9a8482565ce343ad3ea7fc4bc42cb043",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Fortune-Tiger_app-icon_rounded.png"
        },
        {
          name: "Speed Winner",
          GAMEID: "386a9d8e184d9bc7c7aca32a8a5db686",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Speed-Winner_1024_rounded.png"
        },
        {
          name: "Legend of Perseus",
          GAMEID: "6e37f6e1b6042c2147866c4d86206979",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Legend-of-Perseus_1024_rounded.png"
        },
        {
          name: "Honey Trap of Diao Chan",
          GAMEID: "cd0cc7e653b42133d57145d5505d4e96",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Honey-Trap-of-Diao-Chan_rounded_1024.png"
        },
        {
          name: "Fortune Gods",
          GAMEID: "d3aad7ca1486eb3f145e2c43f38b559c",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Fortune-Gods_rounded_1024.png"
        },
        {
          name: "Win Win Won",
          GAMEID: "43862cc768882dff441a60b26dcec1c0",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Win-Win-Won_rounded_1024.png"
        },
        {
          name: "Medusa II",
          GAMEID: "1c6d773d6a616d74e2573343a5dcecc3",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Medusa-II_rounded_1024.png"
        },
        {
          name: "Tree of Fortune",
          GAMEID: "e7d7e8396619459db2c178ed72f81049",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Tree-of-Fortune_rounded_1024.png"
        },
        {
          name: "Medusa",
          GAMEID: "dcc55631d793ad44be98d21c99f7e361",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Medusa_rounded_1024.png"
        },
        {
          name: "Plushie Frenzy",
          GAMEID: "b34c5e632cdc53fc67f1a5eec5758af7",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Plushie-Frenzy_rounded_1024.png"
        },
        {
          name: "Gem Saviour",
          GAMEID: "9e795df6bdf093a144e714fd35afbb7a",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Gem-Saviour_rounded_1024.png"
        },
        {
          name: "Hood vs Wolf",
          GAMEID: "222ce90a04a2246eecd5216454f9792f",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Hood-vs-Wolf_rounded_1024.png"
        },
        {
          name: "Hotpot",
          GAMEID: "2fea77daa52fd607ed0abe816e4dc7c7",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Hotpot_rounded_1024.png"
        },
        {
          name: "Dragon Legend",
          GAMEID: "b990b58ed9e1aa341b3164f49bcb1517",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Dragon-Legend_Icon_Rounded_1024.png"
        },
        {
          name: "Mr. Hallow-Win",
          GAMEID: "12e94577c713a431ef7765394bb9be2f",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/MrHallow-Win_Icon_Rounded_1024.png"
        },
        {
          name: "Legend of Hou Yi",
          GAMEID: "1ed6fe92243975f73c944342119a1336",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Legend-of-Hou-Yi_Icon_Rounded_1024.png"
        },
        {
          name: "Prosperity Lion",
          GAMEID: "1fcb23fa9fac3ca32e20adfe90028de3",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Prosperity-Lion_Icon_Rounded_1024.png"
        },
        {
          name: "Hip Hop Panda",
          GAMEID: "5fdbd55ac67eea146b93939ee060cd54",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Hip-Hop-Panda_Icon_Rounded_1024.png"
        },
        {
          name: "Santa's Gift Rush",
          GAMEID: "864edc20e589a738c632f8a49a2e02a3",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Santas-Gift-Rush_Icon_Rounded_1024.png"
        },
        {
          name: "Baccarat Deluxe",
          GAMEID: "22c3b8df172b40ac24a7e9c909e0e50e",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Baccarat-Deluxe_Icon_Rounded_1024.png"
        },
        {
          name: "Gem Saviour Sword",
          GAMEID: "4bbb563e9cf0211a3433beeebe70f35b",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Gem-Saviour-Sword_rounded_1024.png"
        },
        {
          name: "Piggy Gold",
          GAMEID: "a9d874dd5305212b09845fc88f72e02d",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Piggy-Gold_Icon_Rounded_1024.png"
        },
        {
          name: "Symbols of Egypt",
          GAMEID: "0c7c636333c3c0807d2da26e1f0c8cd1",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Symbols-of-Egypt_Icon_Rounded_1024.png"
        },
        {
          name: "Emperor's Favour",
          GAMEID: "12766ca09f503fec11f391199fce5e24",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Emperors-Favour_Icon_Rounded_1024.png"
        },
        {
          name: "Ganesha Gold",
          GAMEID: "8dcea650a5a4d96530a77e6df8f61923",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Ganesha-Gold_rounded_1024.png"
        },
        {
          name: "Jungle Delight",
          GAMEID: "232e8e0c74f9bb16ab676e5ed49d72b4",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Jungle-Delight_Icon_Rounded_1024.png"
        },
        {
          name: "Journey to the Wealth",
          GAMEID: "139f7ae7151a8bd388511bd8b7ce0c40",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Journey-to-the-Wealth_Icon_Rounded_1024.png"
        },
        {
          name: "Flirting Scholar",
          GAMEID: "0c884fde76cbc187f2797c4f76532220",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Flirting-Scholar_rounded_1024.png"
        },
        {
          name: "Ninja vs Samurai",
          GAMEID: "2eb712d4bb30e4594032ebf1464618b1",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Ninja-vs-Samurai_rounded_1024.png"
        },
        {
          name: "Muay Thai Champion",
          GAMEID: "82127ece1232c6762c81fedb73c99756",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Muay-Thai-Champion_rounded_1024.png"
        },
        {
          name: "Dragon Tiger Luck",
          GAMEID: "3d3dd6e2fd819832528108e0af197c43",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Dragon-Tiger-Luck_rounded_1024.png"
        },
        {
          name: "Fortune Mouse",
          GAMEID: "8e5a4dd7da06fb68165d13f8bcd06328",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Fortune-Mouse_rounded_1024.png"
        },
        {
          name: "Reel Love",
          GAMEID: "813138051d990c0c21fb78015b14cbef",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Reel-Love_rounded_1024.png"
        },
        {
          name: "Gem Saviour Conquest",
          GAMEID: "07d9e7940f430557447cb19692ae4409",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Gem-Saviour-Conquest_rounded_1024.png"
        },
        {
          name: "Shaolin Soccer",
          GAMEID: "da483088a7f719026e93ba95c5547a8c",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Shaolin-Soccer_rounded_1024.png"
        },
        {
          name: "Candy Burst",
          GAMEID: "27237d7e8d9b183c92fa9f6ab9832edc",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Candy-Burst_rounded_1024.png"
        },
        {
          name: "Bikini Paradise",
          GAMEID: "18f7f3fdda3e951989731b7204572a8f",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Bikini-Paradise_rounded_1024.png"
        },
        {
          name: "Genie's 3 Wishes",
          GAMEID: "16e34863dada5465919b289f83c494a1",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Genies-3-Wishes_rounded_1024.png"
        },
        {
          name: "Circus Delight",
          GAMEID: "5a11d239f4368b4ec21d31e5979d85cf",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Circus-Delight_icon_1024_rounded.png"
        },
        {
          name: "Secrets of Cleopatra",
          GAMEID: "7028ed373d5bffeeb22fa90c4066bd9e",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Secrets-of-Cleopatra_icon_1024_rounded.png"
        },
        {
          name: "Vampire's Charm",
          GAMEID: "8912f36ea0ca97fc6911fc21b3be6f6a",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Vampires-Charm_app-icon_rounded_1024.png"
        },
        {
          name: "Jewels of Prosperity",
          GAMEID: "f55a666db274fcf210dd69801ae7e87a",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Jewels-of-Prosperity_rounded_1024.png"
        },
        {
          name: "Jack Frost's Winter",
          GAMEID: "0a8772ad753cfce2c03c0599ad60c74c",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Jack-Frosts-Winter_icon_1024_rounded.png"
        },
        {
          name: "Galactic Gems",
          GAMEID: "5d26d9ec03d3bc031e49abd5b0ffbdda",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Galactic-Gems_1024_rounded.png"
        },
        {
          name: "Guardians of Ice and Fire",
          GAMEID: "4e2f6b7602035730e0e8ee89675a417c",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Guardians-of-Ice-and-Fire_rounded_1024.png"
        },
        {
          name: "Opera Dynasty",
          GAMEID: "c9ec6bce856aafad85f7de5405f7b1c3",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Opera-Dynasty_icon_1024_rounded.png"
        },
        {
          name: "Majestic Treasures",
          GAMEID: "894240c0ef08d5c2e29b231013e1514d",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Majestic-Treasures_icon_1024_rounded.png"
        },
        {
          name: "Candy Bonanza",
          GAMEID: "bbe2320adc5c506e7e56a2d24d96a252",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Candy-Bonanza-icon_1024_rounded.png"
        },
        {
          name: "Heist  Stakes",
          GAMEID: "a4a67f1259cabed59e338e30149ceb0f",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Heist-Stakes_icon_1024_rounded.png"
        },
        {
          name: "Rise of Apollo",
          GAMEID: "3da7ee034052b8cb90c6ca060652ded4",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Rise-of-Apollo_1024_rounded.png"
        },
        {
          name: "Mermaid Riches",
          GAMEID: "a9d7a5af417a94caf554170e6b345e57",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Mermaid-Riches-icon_1024_rounded.png"
        },
        {
          name: "Raider Jane's Crypt of Fortune",
          GAMEID: "24d8e1dbc5cface0907f5a21ecd56753",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Raider-Janes-Crypt-of-Fortune_1024_rounded.png"
        },
        {
          name: "Supermarket Spree",
          GAMEID: "7ef03497fc0b21c34b137e85b1e409cd",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Supermarket-Spree_rounded_1024.png"
        },
        {
          name: "Buffalo Win",
          GAMEID: "2818a7add6e10b2ec5f938d7ae0efb04",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Buffalo-Win_icon_1024_rounded.png"
        },
        {
          name: "Legendary Monkey King",
          GAMEID: "5cdeba2ab48d6ba345b1a4de8e2776b5",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Legendary-Monkey-King_icon_1024_rounded.png"
        },
        {
          name: "Spirited Wonders",
          GAMEID: "87a05c81af5635bed41765bfd076ee15",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Spirited-Wonders_app-icon_rounded.png"
        },
        {
          name: "Emoji Riches",
          GAMEID: "101ca3ff83b149dcf3439309e9b32142",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Emoji-Riches_app-Icon_1024_rounded.png"
        },
        {
          name: "Mask Carnival",
          GAMEID: "adf297c2666c69b3abc3b61618d593b8",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Mask-Carnival_app-icon_rounded.png"
        },
        {
          name: "Oriental Prosperity",
          GAMEID: "23b43b58e11aadb1f27fd05ba41e9819",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Oriental-Prosperity_icon_1024_rounded.png"
        },
        {
          name: "Garuda Gems",
          GAMEID: "aa609892f551de2053e92427dc4ae17f",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Garuda-Gems_1024_rounded.png"
        },
        {
          name: "Destiny of Sun & Moon",
          GAMEID: "617ca04ffcffbc543a1a30cacdac98fa",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Destiny-of-Sun-and-Moon_icon_1024_rounded.png"
        },
        {
          name: "Butterfly Blossom",
          GAMEID: "116989bb267a72035bd01818c5496126",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Butterfly-Blossom_1024_rounded.png"
        },
        {
          name: "Rooster Rumble",
          GAMEID: "5c371d9fca6109c954de93ac7986c5db",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Rooster-Rumble_app-icon_rounded.png"
        },
        {
          name: "The Queen's Banquet",
          GAMEID: "1b317b5f8bf2ca0cc609307810407426",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/The-Queens-Banquet_icon_1024_rounded.png"
        },
        {
          name: "Battleground Royale",
          GAMEID: "e9f92f6edc2dac2d08bc345ee036260c",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Battleground-Royale_icon_1024_rounded.png"
        },
        {
          name: "Win Win Fish Prawn Crab",
          GAMEID: "9b344f0b2a9bda427684be60597d2fc6",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Win-Win-Fish-Prawn-Crab_rounded_1024.png"
        },
        {
          name: "Lucky Piggy",
          GAMEID: "66fadac68ed45e23def86c06cc811820",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Lucky-Piggy_icon_1024_rounded.png"
        },
        {
          name: "Wild Coaster",
          GAMEID: "a06f1a154698243bf2484853d38e5fbb",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Wild-Coaster_app-icon_rounded.png"
        },
        {
          name: "Totem Wonders",
          GAMEID: "a03c6e7a918132b50f9caa297df1752d",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Totem-Wonders_icon_1024_rounded.png"
        },
        {
          name: "Alchemy Gold",
          GAMEID: "9860c865264dcacad1ef37176cdefc1a",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Alchemy-Gold_1024_rounded.png"
        },
        {
          name: "Asgardian Rising",
          GAMEID: "08d92dc2ca14f42c681b44297386d600",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Asgardian-Rising_appicon_rounded.png"
        },
        {
          name: "Midas Fortune",
          GAMEID: "a2fd6b0cadc8fefccfb0d063b1f81d85",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Midas-Fortune_appicon_rounded.png"
        },
        {
          name: "Fortune Rabbit",
          GAMEID: "e175cdd3215a02f5539cc8354a149b75",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Fortune-Rabbit_appicon_rounded.png"
        },
        {
          name: "Rave Party Fever",
          GAMEID: "901aa1b709a937f6a04baddb98a8d1d3",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Rave-Party-Fever_1024_rounded.png"
        },
        {
          name: "Hawaiian Tiki",
          GAMEID: "35d6743ae5d73a3359f143cbb44ede09",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Hawaiian-Tiki_icon_1024_rounded.png"
        },
        {
          name: "Bakery Bonanza",
          GAMEID: "d0fe7aa2f7ed5778190b1e60d94e6773",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Bakery-Bonanza_app-Icon_1024_rounded.png"
        },
        {
          name: "Songkran Splash",
          GAMEID: "894b1c7609629cf9b3d127d9dbaa372c",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Songkran-Splash_appicon_rounded.png"
        },
        {
          name: "Mystical Spirits",
          GAMEID: "3b2d4d1ae24b1c3ad29556a6cf875f11",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Mystical-Spirits_icon_1024_rounded.png"
        },
        {
          name: "Super Golf Drive",
          GAMEID: "d37dde2adb52e0ea708c0ccd6877b1b3",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Super-Golf-Drive_icon_1024_rounded.png"
        },
        {
          name: "Lucky Clover Lady",
          GAMEID: "288f290554746bb32322a79b96ecdcbb",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Lucky-Clover-Lady_1024_rounded.png"
        },
        {
          name: "Fruity Candy",
          GAMEID: "9f2c89ae5b7c0894c9ee9e223e3fd9d8",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Fruity-Candy_1024_rounded.png"
        },
        {
          name: "Cruise Royale",
          GAMEID: "8489d662ccc07a2e9677729f76e26ae8",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Cruise-Royale_icon_1024_rounded.png"
        },
        {
          name: "Safari Wilds",
          GAMEID: "97c6f05ef6a0a34cad10d5e00edc909c",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Safari-Wilds_appicon_rounded.png"
        },
        {
          name: "Gladiator's Glory",
          GAMEID: "2454dc7cfdc651b7318950453bc3f617",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Gladiators-Glory_appicon_1024_rounded.png"
        },
        {
          name: "Ninja Racoon Frenzy",
          GAMEID: "6d1937d2e7f87306333443c99ac2c03f",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Ninja-Racoon-Frenzy_1024_rounded.png"
        },
        {
          name: "Ultimate Striker",
          GAMEID: "4415d83cd9c74299814c1473db83bf7f",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Ultimate-Striker_appicon_rounded.png"
        },
        {
          name: "Wild Heist Cashout",
          GAMEID: "028bd89b2120e880bcf1968c37277460",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Wild-Heist-Cashout_appicon_1024_rounded.png"
        },
        {
          name: "Forge of Wealth",
          GAMEID: "f8ec50fc2ef996e6c182fd2fe59a16fa",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Forge-of-Wealth_1024_rounded.png"
        },
        {
          name: "Mafia Mayhem",
          GAMEID: "c7b3016c70a06ddbb2355a3aee4179d0",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Mafia-Mayhem_1024_rounded.png"
        },
        {
          name: "Werewolf Hunt",
          GAMEID: "2ac70bee7b47c172381e55f7e644d92e",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Werewolfs-Hunt_icon_1024_rounded.png"
        },
        {
          name: "Tsar Treasures",
          GAMEID: "1eb6a959aadf0491f4a648762d8d262a",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Tsar-Treasures_icon_1024_rounded.png"
        },
        {
          name: "Fortune Dragon",
          GAMEID: "c5435a8a73707a3a8bb4fe8baaaef3d2",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Fortune-Dragon_icon_1024_rounded.png"
        },
        {
          name: "Dragon Hatch 2",
          GAMEID: "910f25689073d17680be453d7ed90ce2",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Dragon-Hatch2_icon_1024_rounded.png"
        },
        {
          name: "Gemstones Gold",
          GAMEID: "877c9b2ec1c5e0505129315948f9bbfa",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Gemstones-Gold_appicon_rounded.png"
        },
        {
          name: "Cash Mania",
          GAMEID: "c8bbb41367b3971ed3467c2f0c2627a4",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Cash-Mania_appicon_rounded.png"
        },
        {
          name: "Wild Ape #3258",
          GAMEID: "9b93cb0dc46d847864c87ed42a3428bb",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Wild-Ape_rounded.png"
        },
        {
          name: "Pinata Wins",
          GAMEID: "f08cc025e23ee049b570517867c74be0",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Pinata-Wins_1024_rounded.png"
        },
        {
          name: "Mystic Potion",
          GAMEID: "e61bde75d590e943d2c5c6d432b29b46",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Mystic-Potion.png"
        },
        {
          name: "Anubis Wrath",
          GAMEID: "c268154a85669eea35aa46387834ac76",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/Anubis-Wrath.png"
        },
        {
          name: "Chicky Run",
          GAMEID: "c3e600005f72f1d1cabe758e206daf57",
          "game_type": "Gamble Game",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/chicky-run_icon_1024_rounded.png"
        },
        {
          name: "Zombie Outbreak",
          GAMEID: "83b6eceea77859c14426b05480b96c34",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/zombie-outbreaks_appicon_rounded.png"
        },
        {
          name: "Futebol Fever",
          GAMEID: "314afef87ff2974867234ac317b37f4c",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/futebol-fever_icon_1024_rounded.png"
        },
        {
          name: "Shark Bounty",
          GAMEID: "42cf824884f8ecdaf39862c9a15bf1f1",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/shark-hunter_1024_rounded.png"
        },
        {
          name: "Yakuza Honor",
          GAMEID: "e4772d4ef1de4217915c678d0d1722a8",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/yakuza-honor_1024_rounded.png"
        },
        {
          name: "Wings of Iguazu",
          GAMEID: "6ae667b26f908e5ebe8976ca334fd472",
          provider: "pgsoft",
          src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/pg/wings-of-iguazu_icon_1024_rounded.png"
        }
      ]

      const openGameById = async (slider) => {
        console.log("slide", slider);
    
        userdata(async (res) => {
          if (res?.status) {
            // console.log(res, "res is user data");
            // const mobile = encodeURIComponent(res.data.phone_user);
            // const name = res.data.name_user;
            if (slider.provider === "pgsoft") {
              const fetchGameLink = async () => {
                const t = slider.GAMEID; // Game ID, not auth
    
                const resp= await axios
                  .post(base_url+
                    `/openJsGame`,
                    { game_uid: t }, // Sending Game ID
                    {
                      headers: {
                        "Content-Type": "application/json",
                      },
                      withCredentials: true, // Send cookies for authentication
                    }
                  )
                  return resp.data.game_url;
              };
    
              toast.promise(
                fetchGameLink().then((gameUrl) => {
                  navigate("/lobby", { state: gameUrl }, { replace: true });
                  // console.log('gameurl',gameUrl);
                  // window.location.href=gameUrl
                }),
                {
                  loading: "Generating game link...",
                  success: "Game link generated!",
                  error: "Error generating game link.",
                }
              );
            } 
          } else {
            setActive(true);
            toast.error("Please Login To Play!");
          }
        });
      };

      useEffect(() => {
        window.scrollTo(0,0);
          const handleResize = () => {
            // Start closed and let the visitor open it. Forcing it open
      // above 991px put a fixed panel over the page content.
      setSidebar(false);
          };
      
          // Add event listener for resize
          window.addEventListener("resize", handleResize);
      
          // Initial check to set the correct sidebar state
          handleResize();
      
          // Cleanup the event listener on component unmount
          return () => {
            window.removeEventListener("resize", handleResize);
          };
        }, []);

    return (
        <>
            {<LoginReg active={active} setactive={setActive}/>}
      <app-root _nghost-jrx-c101="" ng-version="12.2.16">
            <div _ngcontent-jrx-c101="">
              <app-landing-page-new _nghost-jrx-c95="" className="ng-star-inserted">
                <div _ngcontent-jrx-c95="" className="head-container">
                  <div _ngcontent-jrx-c95="" className="body-container">
                    <Sidebar isSidebar={isSidebar} setSidebar={setSidebar} />
                    <div
                      _ngcontent-jrx-c95=""
                      className={`rightbar`}
                      style={{
                        width: isSidebar ? '' : "1500%",
                        transition: "width 0.3s ease-in-out",
                      }}
                    >
                      <Header isSidebar={isSidebar} setSidebar={setSidebar} />
      
                  <h1 className='pl-5 text-yellow fs-2'>Pg soft Games</h1>
      
                  <div className="d-flex flex-wrap justify-content-center gp">
                      {allGames?.map((game, index) => (
                          <div key={index} className="rounded-4 p-3 text-center" style={{ width: "19rem", boxShadow: "0px 5px 15px rgba(255, 242, 140, 0.4)" }}>
                          <img
                              src={game.src}
                              alt="jili games"
                             
                              style={{ width: "100%", height: "250px", objectFit: "cover" }}
                          />
                          <p className="text-white mt-2">{game.name}</p>
                          <button className="btn btn-info w-100 container" onClick={() => openGameById(game)}>
                              Play
                          </button>
                          </div>
                      ))}
                  </div>

                      
                    </div>
                  </div>
                </div>
              </app-landing-page-new>
            </div>
          </app-root>
</>
    )
}

export default PgSoftAll
